var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ImmersivePage",
    { attrs: { route: _vm.homePageLink, appBarTitle: _vm.exam.title || "" } },
    [
      _vm.loading || !_vm.currentQuestion
        ? _c("KCircularLoader")
        : _c(
            "div",
            [
              _c(
                "KGrid",
                { attrs: { gridStyle: _vm.gridStyle } },
                [
                  _vm.showQuestionsList
                    ? _c(
                        "KGridItem",
                        {
                          ref: "questionListWrapper",
                          staticClass: "column-pane",
                          attrs: { layout12: { span: 4 } },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "column-contents-wrapper" },
                            [
                              _c(
                                "KPageContainer",
                                { staticStyle: { padding: "0" } },
                                [
                                  _c("AnswerHistory", {
                                    attrs: {
                                      pastattempts: _vm.pastattempts,
                                      sections: _vm.sections,
                                      currentSectionIndex:
                                        _vm.currentSectionIndex,
                                      questionNumber: _vm.questionNumber,
                                      questionItem: _vm.attemptLogItemValue,
                                      currentQuestionAnswered:
                                        _vm.currentQuestionAnswered,
                                      wrapperComponentRefs: _vm.$refs,
                                    },
                                    on: { goToQuestion: _vm.goToQuestion },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "KGridItem",
                    {
                      staticClass: "column-pane",
                      style: !_vm.showQuestionsList
                        ? { overflow: "unset" }
                        : {},
                      attrs: { layout12: { span: 8 } },
                    },
                    [
                      _c(
                        "main",
                        {
                          class: {
                            "column-contents-wrapper": !_vm.windowIsSmall,
                          },
                        },
                        [
                          _vm.windowIsLarge
                            ? _c(
                                "KPageContainer",
                                {
                                  staticStyle: { "overflow-x": "visible" },
                                  attrs: { dir: "auto" },
                                },
                                [
                                  _c(
                                    "KGrid",
                                    [
                                      _c(
                                        "KGridItem",
                                        { attrs: { layout12: { span: 8 } } },
                                        [
                                          _c(
                                            "h2",
                                            { staticClass: "section-title" },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.displaySectionTitle(
                                                      _vm.currentSection,
                                                      _vm.currentSectionIndex
                                                    )
                                                  ) +
                                                  "\n                "
                                              ),
                                            ]
                                          ),
                                          _vm.currentSection.description
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.currentSection
                                                      .description
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                      _c(
                                        "KGridItem",
                                        { attrs: { layout12: { span: 4 } } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              style: {
                                                margin: "2em auto 0",
                                                textAlign: "center",
                                                width: "100%",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.coreString(
                                                      "timeSpentLabel"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _c("TimeDuration", {
                                                staticClass: "timer",
                                                attrs: {
                                                  "aria-live": "polite",
                                                  role: "timer",
                                                  seconds: _vm.time_spent,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c(
                                    "KPageContainer",
                                    {
                                      staticClass: "quiz-container",
                                      attrs: { dir: "auto" },
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.coreString("timeSpentLabel")
                                          ) + ":"
                                        ),
                                      ]),
                                      _c("TimeDuration", {
                                        staticClass: "timer",
                                        attrs: {
                                          "aria-live": "polite",
                                          role: "timer",
                                          seconds: _vm.time_spent,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "KPageContainer",
                                    {
                                      staticClass: "quiz-container",
                                      attrs: { dir: "auto" },
                                    },
                                    [
                                      _vm.windowIsSmall || _vm.windowIsMedium
                                        ? _c(
                                            "div",
                                            [
                                              _vm.sectionSelectOptions.length >
                                              1
                                                ? _c("KSelect", {
                                                    attrs: {
                                                      value:
                                                        _vm.currentSectionOption,
                                                      options:
                                                        _vm.sectionSelectOptions,
                                                      label:
                                                        _vm.quizSectionsLabel$(),
                                                    },
                                                    on: {
                                                      select:
                                                        _vm.handleSectionOptionChange,
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "display",
                                                          fn: function () {
                                                            return [
                                                              _c("KIcon", {
                                                                staticClass:
                                                                  "dot",
                                                                attrs: {
                                                                  icon: _vm.sectionQuestionsIcon(
                                                                    _vm.currentSectionIndex
                                                                  ),
                                                                  color:
                                                                    _vm.sectionQuestionsIconColor(
                                                                      _vm.currentSectionIndex
                                                                    ),
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm
                                                                      .currentSectionOption
                                                                      .label
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                          proxy: true,
                                                        },
                                                        {
                                                          key: "option",
                                                          fn: function ({
                                                            index,
                                                            option,
                                                          }) {
                                                            return [
                                                              _c("KIcon", {
                                                                staticClass:
                                                                  "dot",
                                                                attrs: {
                                                                  icon: _vm.sectionQuestionsIcon(
                                                                    index
                                                                  ),
                                                                  color:
                                                                    _vm.sectionQuestionsIconColor(
                                                                      index
                                                                    ),
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    option.label
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      false,
                                                      808899403
                                                    ),
                                                  })
                                                : _vm.currentSectionOption.label
                                                ? _c(
                                                    "h2",
                                                    {
                                                      staticClass:
                                                        "section-select",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                  " +
                                                          _vm._s(
                                                            _vm
                                                              .currentSectionOption
                                                              .label
                                                          ) +
                                                          "\n                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.currentSection.description
                                        ? _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.currentSection.description
                                              )
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.content && _vm.content.duration
                                        ? _c("p", [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.learnString(
                                                    "suggestedTime"
                                                  )
                                                ) +
                                                "\n              "
                                            ),
                                          ])
                                        : _vm._e(),
                                      _vm.content && _vm.content.duration
                                        ? _c("SuggestedTime", {
                                            staticClass: "timer",
                                            attrs: {
                                              seconds: _vm.content.duration,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                          _c(
                            "KPageContainer",
                            { staticStyle: { "overflow-x": "visible" } },
                            [
                              _vm.windowIsSmall || _vm.windowIsMedium
                                ? _c("KSelect", {
                                    staticStyle: { "margin-top": "1em" },
                                    attrs: {
                                      value: _vm.currentQuestionOption,
                                      options: _vm.questionSelectOptions,
                                      label: _vm.questionsLabel$(),
                                    },
                                    on: {
                                      select: _vm.handleQuestionOptionChange,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "display",
                                          fn: function () {
                                            return [
                                              _vm.currentQuestionOption.disabled
                                                ? _c("KIcon", {
                                                    staticClass: "dot",
                                                    attrs: {
                                                      icon: "warning",
                                                      color:
                                                        _vm.$themePalette.yellow
                                                          .v_600,
                                                    },
                                                  })
                                                : _c("KIcon", {
                                                    staticClass: "dot",
                                                    attrs: {
                                                      icon: _vm.isAnswered(
                                                        _vm
                                                          .currentQuestionOption
                                                          .value
                                                      )
                                                        ? "unpublishedResource"
                                                        : "unpublishedChange",
                                                      color: _vm.isAnswered(
                                                        _vm
                                                          .currentQuestionOption
                                                          .value
                                                      )
                                                        ? _vm.$themeTokens
                                                            .progress
                                                        : _vm.$themeTokens
                                                            .textDisabled,
                                                    },
                                                  }),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(
                                                      _vm.currentQuestionOption
                                                        .label
                                                    ) +
                                                    "\n                "
                                                ),
                                              ]),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                        {
                                          key: "option",
                                          fn: function ({ option }) {
                                            return [
                                              option.disabled
                                                ? _c("KIcon", {
                                                    staticClass: "dot",
                                                    attrs: {
                                                      icon: "warning",
                                                      color:
                                                        _vm.$themePalette.yellow
                                                          .v_600,
                                                    },
                                                  })
                                                : _c("KIcon", {
                                                    staticClass: "dot",
                                                    attrs: {
                                                      icon: _vm.isAnswered(
                                                        option.value
                                                      )
                                                        ? "unpublishedResource"
                                                        : "unpublishedChange",
                                                      color: _vm.isAnswered(
                                                        option.value
                                                      )
                                                        ? _vm.$themeTokens
                                                            .progress
                                                        : _vm.$themeTokens
                                                            .textDisabled,
                                                    },
                                                  }),
                                              _c("span", [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(option.label) +
                                                    "\n                "
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4093622745
                                    ),
                                  })
                                : _c(
                                    "h2",
                                    { staticClass: "number-of-questions" },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$tr("question", {
                                              num: _vm.questionNumber + 1,
                                              total: _vm.exam.question_count,
                                            })
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                              _vm.content && _vm.itemId
                                ? _c("ContentViewer", {
                                    ref: "contentViewer",
                                    attrs: {
                                      files: _vm.content.files,
                                      extraFields: _vm.content.extra_fields,
                                      itemId: _vm.itemId,
                                      assessment: true,
                                      allowHints: false,
                                      answerState: _vm.currentAttempt.answer,
                                    },
                                    on: { interaction: _vm.interactionHandler },
                                  })
                                : _c("ResourceSyncingUiAlert", {
                                    attrs: { multiple: false },
                                  }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "BottomAppBar",
                { attrs: { maxWidth: null } },
                [
                  _c(
                    "KButtonGroup",
                    { class: { spread: !_vm.windowIsLarge } },
                    [
                      _c(
                        "KButton",
                        {
                          attrs: {
                            disabled: _vm.questionNumber === 0,
                            primary: true,
                            dir: _vm.layoutDirReset,
                            appearanceOverrides: _vm.navigationButtonStyle,
                            "aria-label": _vm.$tr("previousQuestion"),
                          },
                          on: { click: _vm.goToPreviousQuestion },
                          scopedSlots: _vm._u([
                            {
                              key: "icon",
                              fn: function () {
                                return [
                                  _c("KIcon", {
                                    style: _vm.navigationIconStylePrevious,
                                    attrs: {
                                      icon: "back",
                                      color: _vm.$themeTokens.textInverted,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm.displayNavigationButtonLabel
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$tr("previousQuestion"))),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      _c(
                        "KButton",
                        {
                          attrs: {
                            disabled:
                              _vm.questionNumber ===
                              _vm.exam.question_count - 1,
                            primary: true,
                            dir: _vm.layoutDirReset,
                            "aria-label": _vm.$tr("nextQuestion"),
                            appearanceOverrides: _vm.navigationButtonStyle,
                          },
                          on: { click: _vm.goToNextQuestion },
                          scopedSlots: _vm._u([
                            {
                              key: "iconAfter",
                              fn: function () {
                                return [
                                  _c("KIcon", {
                                    style: _vm.navigationIconStyleNext,
                                    attrs: {
                                      icon: "forward",
                                      color: _vm.$themeTokens.textInverted,
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ]),
                        },
                        [
                          _vm.displayNavigationButtonLabel
                            ? _c("span", [
                                _vm._v(_vm._s(_vm.$tr("nextQuestion"))),
                              ])
                            : _vm._e(),
                        ]
                      ),
                      !_vm.windowIsLarge && _vm.questionsUnanswered === 0
                        ? _c("KButton", {
                            attrs: {
                              text: _vm.$tr("submitExam"),
                              primary: true,
                              appearance: "raised-button",
                            },
                            on: { click: _vm.finishExam },
                          })
                        : !_vm.windowIsLarge && !_vm.missingResources
                        ? _c("KButton", {
                            attrs: {
                              text: _vm.$tr("submitExam"),
                              primary: false,
                              appearance: "flat-button",
                            },
                            on: { click: _vm.toggleModal },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm.windowIsLarge
                    ? _c(
                        "div",
                        {
                          staticClass: "left-align",
                          attrs: { dir: _vm.layoutDirReset },
                        },
                        [
                          !_vm.missingResources
                            ? _c("div", { staticClass: "answered" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.answeredText) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                          _vm.questionsUnanswered === 0
                            ? _c("KButton", {
                                attrs: {
                                  text: _vm.$tr("submitExam"),
                                  primary: true,
                                  appearance: "raised-button",
                                },
                                on: { click: _vm.finishExam },
                              })
                            : !_vm.missingResources
                            ? _c("KButton", {
                                attrs: {
                                  text: _vm.$tr("submitExam"),
                                  primary: false,
                                  appearance: "flat-button",
                                },
                                on: { click: _vm.toggleModal },
                              })
                            : _vm._e(),
                          _vm.missingResources
                            ? _c("div", { staticClass: "nosubmit" }, [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.$tr("unableToSubmit")) +
                                    "\n        "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
      _vm.submitModalOpen
        ? _c(
            "KModal",
            {
              attrs: {
                title: _vm.$tr("submitExam"),
                submitText: _vm.$tr("submitExam"),
                cancelText: _vm.coreString("cancelAction"),
              },
              on: { submit: _vm.finishExam, cancel: _vm.toggleModal },
            },
            [
              _vm.questionsUnanswered
                ? _c("p", [
                    _vm._v(
                      "\n      " +
                        _vm._s(
                          _vm.$tr("unanswered", {
                            numLeft: _vm.questionsUnanswered,
                          })
                        ) +
                        "\n    "
                    ),
                  ])
                : _vm._e(),
              _c("p", [_vm._v(_vm._s(_vm.$tr("areYouSure")))]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }